import React, { useCallback, useMemo, useState } from 'react';

import ProfileStat from '@atoms/ProfileStat';
import { RelationshipsModalTabs } from '@hooks/useRelationshipModalData';
import RelationshipsModal from '@molecules/RelationshipsModal';
// import { useGetRelationshipStats } from '@queries/people';
import { useGetUserFavoriteSessions } from '@sunrise-ui/api-client';
import { SessionStatus } from '@sunrise-ui/api/events';
import { useDynamicStyles, type WithResponsive } from '@sunrise-ui/primitives';
import { useFocusEffect } from 'expo-router';
import { StyleSheet, View } from 'react-native';

type Props = {
  userId?: string;
  align?: 'vertical' | 'horizontal';
  size?: 'small';
};

export default function ProfileStats({
  userId,
  align = 'horizontal',
  size,
}: Props) {
  const styles = useDynamicStyles(createStyles, { align });
  const [showRelationshipsModal, setShowRelationshipsModal] = useState(false);
  const [relationshipsModalTab, setRelationshipsModalTab] =
    useState<RelationshipsModalTabs>(RelationshipsModalTabs.CONNECTIONS);
  // const { data: stats } = useGetRelationshipStats(userId);

  // Get all favorited sessions
  const { data: favoritedSessions } = useGetUserFavoriteSessions({ userId });

  // Calculate total count of confirmed favorited sessions (both upcoming and past)
  const totalFavoritedEventsCount = useMemo(() => {
    if (!favoritedSessions) return 0;

    // Only count confirmed sessions
    return favoritedSessions.filter(
      (session) => session.status === SessionStatus.Confirmed,
    ).length;
  }, [favoritedSessions]);

  // const openRelationshipsModal = (tab: RelationshipsModalTabs) => () => {
  //   if (!userId) return;

  //   setShowRelationshipsModal(true);
  //   setRelationshipsModalTab(tab);
  // };

  const closeRelationshipsModal = () => {
    setShowRelationshipsModal(false);
  };

  useFocusEffect(useCallback(() => closeRelationshipsModal, [userId]));

  return (
    <View style={styles.profileStats}>
      <ProfileStat
        value={totalFavoritedEventsCount}
        label="event"
        size={size}
      />
      {/* TODO: Commented out for now */}
      {/* <ProfileStat
        value={stats?.follower_count}
        label="follower"
        onPress={openRelationshipsModal(RelationshipsModalTabs.FOLLOWERS)}
      />
      <ProfileStat
        value={stats?.following_count}
        label="following"
        labelFormatting="none"
        onPress={openRelationshipsModal(RelationshipsModalTabs.FOLLOWING)}
      /> */}
      {userId && (
        <RelationshipsModal
          currentTab={relationshipsModalTab}
          setCurrentTab={setRelationshipsModalTab}
          visible={showRelationshipsModal}
          hideModal={closeRelationshipsModal}
          userId={userId}
        />
      )}
    </View>
  );
}

const createStyles = ({ align }: WithResponsive<Props>) =>
  StyleSheet.create({
    profileStats: {
      display: 'flex',
      flexDirection: align === 'vertical' ? 'column' : 'row',
      gap: align === 'vertical' ? 20 : 0,
      justifyContent: 'space-between',
    },
  });
